import { render, staticRenderFns } from "./AdminConfig.vue?vue&type=template&id=3da56492"
import script from "./AdminConfig.vue?vue&type=script&lang=js"
export * from "./AdminConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports